export default "__VITE_ASSET__BvXYFZG1__"